export enum FeedbacksMutations {
    SET_ALL_FEEDBACKS = 'SET_ALL_FEEDBACKS',
    SET_FEEDBACK_AVERAGE = 'SET_FEEDBACK_AVERAGE',
    SET_FEEDBACK_TYPE_COUNT = 'SET_FEEDBACK_TYPE_COUNT',
    SET_MONTH_SUGGESTIONS = 'SET_MONTH_SUGGESTIONS',
}
